var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRestart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.14 19.982"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 55",
    d: "M4.198 2.562H1.5a.4.4 0 01-.459-.411.4.4 0 01.458-.412h4.07a.976.976 0 01.014.11v4a.4.4 0 01-.337.426.405.405 0 01-.462-.259.708.708 0 01-.024-.223V3.244l-.056-.037c-.341.333-.7.647-1.018 1a8.471 8.471 0 00-2.2 5.166 8.653 8.653 0 006.085 8.892 8.663 8.663 0 0010.814-5.7 8.65 8.65 0 00-6.444-11.037 16.234 16.234 0 00-1.776-.2c-.3-.028-.47-.168-.462-.433s.179-.394.475-.4a9.493 9.493 0 019.1 7 9.508 9.508 0 01-5.688 11.326 9.458 9.458 0 01-4.013.643 9.5 9.5 0 01-8.494-6.563A9.478 9.478 0 014.012 2.722c.054-.039.101-.084.186-.16z"
  }))));
}

export default __webpack_public_path__ + "584a50326be0fcfee3fbdc9834b37087.svg";
export { SvgRestart as ReactComponent };